import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    INFRA_DELIVERABLE_PROJECT,
    INFRA_DELIVERABLE_PHASES,
    INFRA_DELIVERABLE_LIST,
    INFRA_DELIVERABLE_FREQUENCY,
    INFRA_DELIVERABLE_ACTIVITY_TYPE,
    INFRA_DELIVERABLE_STATUS_REVIEW,
    INFRA_DELIVERABLE_USERS,
    INFRA_DELIVERABLE_ADD,
    INFRA_DELIVERABLE_UPDATE,
    INFRA_ACTIVITY_LIST,
    INFRA_ACTIVITY_ADD,
    INFRA_ACTIVITY_UPDATE,
    INFRA_ACTIVITY_CANCEL,
    INFRA_ACTIVITY_DOC_DELETE,
} from "../../actions";

import {
    InfrastructureDeliverableProjectSuccess,
    InfrastructureDeliverableProjectError,
    InfrastructureDeliverablePhasesSuccess,
    InfrastructureDeliverablePhasesError,
    InfrastructureDeliverableList,
    InfrastructureDeliverableListSuccess,
    InfrastructureDeliverableListError,
    InfrastructureDeliverableFrequencySuccess,
    InfrastructureDeliverableFrequencyError,
    InfrastructureDeliverableActivityTypeSuccess,
    InfrastructureDeliverableActivityTypeError,
    InfrastructureDeliverableStatusReviewSuccess,
    InfrastructureDeliverableStatusReviewError,
    InfrastructureDeliverableUsersSuccess,
    InfrastructureDeliverableUsersError,
    InfrastructureDeliverableAddSuccess,
    InfrastructureDeliverableAddError,
    InfrastructureDeliverableUpdateSuccess,
    InfrastructureDeliverableUpdateError,
    InfrastructureActivityList,
    InfrastructureActivityListSuccess,
    InfrastructureActivityListError,
    InfrastructureActivityAddSuccess,
    InfrastructureActivityAddError,
    InfrastructureActivityUpdateSuccess,
    InfrastructureActivityUpdateError,
    InfrastructureActivityCancelSuccess,
    InfrastructureActivityCancelError,
    InfrastructureActivityDocDeleteSuccess,
    InfrastructureActivityDocDeleteError,
} from '../../actions';

const getToken = async (auth) => {
    return await auth.currentUser.getIdToken(true);
};

const postJson = async (endpoint, body) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + endpoint, {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: body ? JSON.stringify(body) : undefined,
    });
    return await response.json();
};

/* Watchers */
export function* watchProject() { yield takeEvery(INFRA_DELIVERABLE_PROJECT, onProject); }
export function* watchPhases() { yield takeEvery(INFRA_DELIVERABLE_PHASES, onPhases); }
export function* watchList() { yield takeEvery(INFRA_DELIVERABLE_LIST, onList); }
export function* watchFrequency() { yield takeEvery(INFRA_DELIVERABLE_FREQUENCY, onFrequency); }
export function* watchActivityType() { yield takeEvery(INFRA_DELIVERABLE_ACTIVITY_TYPE, onActivityType); }
export function* watchStatusReview() { yield takeEvery(INFRA_DELIVERABLE_STATUS_REVIEW, onStatusReview); }
export function* watchUsers() { yield takeEvery(INFRA_DELIVERABLE_USERS, onUsers); }
export function* watchAdd() { yield takeEvery(INFRA_DELIVERABLE_ADD, onAdd); }
export function* watchUpdate() { yield takeEvery(INFRA_DELIVERABLE_UPDATE, onUpdate); }
export function* watchActivityList() { yield takeEvery(INFRA_ACTIVITY_LIST, onActivityList); }
export function* watchActivityAdd() { yield takeEvery(INFRA_ACTIVITY_ADD, onActivityAdd); }
export function* watchActivityUpdate() { yield takeEvery(INFRA_ACTIVITY_UPDATE, onActivityUpdate); }
export function* watchActivityCancel() { yield takeEvery(INFRA_ACTIVITY_CANCEL, onActivityCancel); }
export function* watchActivityDocDelete() { yield takeEvery(INFRA_ACTIVITY_DOC_DELETE, onActivityDocDelete); }

/* Handlers */
function* onProject({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/project', payload || {});
        // onList now returns an array; the header only shows a single project.
        const project = Array.isArray(response.data) ? (response.data[0] || null) : response.data;
        yield put(InfrastructureDeliverableProjectSuccess(project));
    } catch (error) {
        yield put(InfrastructureDeliverableProjectError(error));
    }
}

function* onPhases({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/phases', payload || {});
        yield put(InfrastructureDeliverablePhasesSuccess(response.data));
    } catch (error) {
        yield put(InfrastructureDeliverablePhasesError(error));
    }
}

function* onList({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/list', payload);
        yield put(InfrastructureDeliverableListSuccess(response));
    } catch (error) {
        yield put(InfrastructureDeliverableListError(error));
    }
}

function* onFrequency() {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/frequency', {});
        yield put(InfrastructureDeliverableFrequencySuccess(response.data));
    } catch (error) {
        yield put(InfrastructureDeliverableFrequencyError(error));
    }
}

function* onActivityType() {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/activityType', {});
        yield put(InfrastructureDeliverableActivityTypeSuccess(response.data));
    } catch (error) {
        yield put(InfrastructureDeliverableActivityTypeError(error));
    }
}

function* onStatusReview() {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/statusReview', {});
        yield put(InfrastructureDeliverableStatusReviewSuccess(response.data));
    } catch (error) {
        yield put(InfrastructureDeliverableStatusReviewError(error));
    }
}

function* onUsers() {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/users', {});
        yield put(InfrastructureDeliverableUsersSuccess(response.data));
    } catch (error) {
        yield put(InfrastructureDeliverableUsersError(error));
    }
}

function* onAdd({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/add', { data: payload.data });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureDeliverableAddSuccess(response));
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureDeliverableAddError(response));
        }
    } catch (error) {
        yield put(InfrastructureDeliverableAddError(error));
    }
}

function* onUpdate({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/update', { data: payload.data });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureDeliverableUpdateSuccess(response));
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureDeliverableUpdateError(response));
        }
    } catch (error) {
        yield put(InfrastructureDeliverableUpdateError(error));
    }
}

function* onActivityList({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/activity/list', payload);
        yield put(InfrastructureActivityListSuccess({
            data: response.data || [],
            is_locked: response.is_locked || false,
            deliverable_status: response.deliverable_status || null
        }));
    } catch (error) {
        yield put(InfrastructureActivityListError(error));
    }
}

function* onActivityAdd({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/activity/add', { data: payload.data });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureActivityAddSuccess(response));
            if (payload.id_deliverable) {
                yield put(InfrastructureActivityList(payload.id_deliverable));
            }
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureActivityAddError(response));
        }
    } catch (error) {
        yield put(InfrastructureActivityAddError(error));
    }
}

function* onActivityUpdate({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/activity/update', { data: payload.data });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureActivityUpdateSuccess(response));
            if (payload.id_deliverable) {
                yield put(InfrastructureActivityList(payload.id_deliverable));
            }
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureActivityUpdateError(response));
        }
    } catch (error) {
        yield put(InfrastructureActivityUpdateError(error));
    }
}

function* onActivityCancel({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/activity/cancel', { data: { id_activity: payload.id_activity } });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureActivityCancelSuccess(response));
            if (payload.id_deliverable) {
                yield put(InfrastructureActivityList(payload.id_deliverable));
            }
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureActivityCancelError(response));
        }
    } catch (error) {
        NotificationManager.error(error && error.message ? error.message : 'Error', 'Error', 3000, null, null, '');
        yield put(InfrastructureActivityCancelError(error));
    }
}

function* onActivityDocDelete({ payload }) {
    try {
        const response = yield call(postJson, 'infrastructureDeliverable/activity/document/delete', { data: { id_activity_document: payload.id_activity_document } });
        if (response && response.status === true) {
            NotificationManager.success(response.message, 'Éxito', 3000, null, null, '');
            yield put(InfrastructureActivityDocDeleteSuccess(payload.id_activity_document));
            if (payload.id_deliverable) {
                yield put(InfrastructureActivityList(payload.id_deliverable));
            }
        } else {
            NotificationManager.error(response && response.message ? response.message : 'Error', 'Error', 3000, null, null, '');
            yield put(InfrastructureActivityDocDeleteError(response));
        }
    } catch (error) {
        yield put(InfrastructureActivityDocDeleteError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchProject),
        fork(watchPhases),
        fork(watchList),
        fork(watchFrequency),
        fork(watchActivityType),
        fork(watchStatusReview),
        fork(watchUsers),
        fork(watchAdd),
        fork(watchUpdate),
        fork(watchActivityList),
        fork(watchActivityAdd),
        fork(watchActivityUpdate),
        fork(watchActivityCancel),
        fork(watchActivityDocDelete),
    ]);
}
